export const CURSOR_PAGE_SIZE = 50;

export interface CursorPageCache<T> {
  items: T[];
  nextCursor: number | null;
  hasMore: boolean;
}

export interface CursorPaginationMeta {
  nextCursor: number | null;
  hasMore: boolean;
  limit: number;
  total: number;
  totalPages: number;
}

export function parseCursorPagination(res: {
  pagination?: Partial<CursorPaginationMeta> | null;
}): CursorPaginationMeta {
  const limit = res.pagination?.limit ?? CURSOR_PAGE_SIZE;
  const total = res.pagination?.total ?? 0;
  const totalPages =
    res.pagination?.totalPages ?? (total > 0 ? Math.ceil(total / limit) : 1);

  return {
    nextCursor: res.pagination?.nextCursor ?? null,
    hasMore: res.pagination?.hasMore ?? false,
    limit,
    total,
    totalPages,
  };
}

export function appendCursorParams(params: URLSearchParams, cursor: number | null, limit = CURSOR_PAGE_SIZE) {
  if (cursor != null) params.set('cursor', String(cursor));
  params.set('limit', String(limit));
  return params;
}
